<template>
  <v-layou>
    Mon CV :-)
  </v-layou>
</template>

<script>
export default {
  components: {},
};
</script>
